"use client";

import { Image, Text } from "@pamperedchef/design-system";

import { SectionHeading } from "@/composites/landing/SectionHeading";
import type { CmsImage } from "@/composites/landing/types";
import * as styles from "./BrandValuesStrip.module.scss";

export interface BrandValueItem {
	image?: CmsImage;
	title: string;
	caption?: string;
}

export interface BrandValuesStripProps {
	heading?: string;
	/** HTML. */
	subcopy?: string;
	items: BrandValueItem[];
}

/** Brand values row: a section heading over CMS glyphs with title and caption. */
export function BrandValuesStrip({
	heading,
	subcopy,
	items
}: BrandValuesStripProps) {
	if (!items.length) return null;

	return (
		<section
			className={styles["brand-values"]}
			data-component="BrandValuesStrip"
		>
			<SectionHeading
				headline={heading}
				subcopy={subcopy}
				subcopyIsHtml
				alignment="center"
			/>

			<ul className={styles["brand-values__items"]}>
				{items.map((item, index) => (
					<li
						key={`${item.title}-${index}`}
						className={styles["brand-value"]}
					>
						{item.image ? (
							<span
								className={styles["brand-value__icon"]}
								aria-hidden="true"
							>
								<Image
									src={item.image.url}
									alt=""
									className={styles["brand-value__glyph"]}
									objectFit="contain"
								/>
							</span>
						) : null}
						<Text
							tag="p"
							styledAs="mdb"
							className={styles["brand-value__title"]}
						>
							{item.title}
						</Text>
						{item.caption ? (
							<Text
								tag="p"
								styledAs="smr"
								className={styles["brand-value__caption"]}
							>
								{item.caption}
							</Text>
						) : null}
					</li>
				))}
			</ul>
		</section>
	);
}
